// extracted by mini-css-extract-plugin
export default {"certContainer":"CVEducation_certContainer__tjLHP"};